/* Founder-Story LP (page.lp-adv-founder) — reveal-on-scroll + mobile sticky CTA.
   Progressive enhancement: html.sb-fs-js is added by an inline script in
   sb-lp-fs-bar.liquid BEFORE first paint; without JS everything stays visible. */
(function () {
  if (window.__sbFsInit) return;
  window.__sbFsInit = true;

  // Reveal on scroll
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('sb-fs-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.sb-fs-rv').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.sb-fs-rv').forEach(function (el) { el.classList.add('sb-fs-in'); });
  }

  // Sticky mobile CTA: show after the hero, hide while the offer is on screen
  var sticky = document.querySelector('.sb-fs-sticky-cta');
  var offer = document.getElementById('sb-fs-offer') || document.getElementById('sb-funnel-offer');
  var hero = document.querySelector('.sb-fs-hero');
  if (sticky) {
    var offerVisible = false;
    if (offer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        offerVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.05 }).observe(offer);
    }
    var heroBottom = 600;
    var measure = function () { if (hero) heroBottom = hero.offsetTop + hero.offsetHeight; };
    window.addEventListener('load', measure);
    measure();
    var update = function () {
      sticky.classList.toggle('sb-fs-show', window.scrollY > heroBottom && !offerVisible);
    };
    window.addEventListener('scroll', update, { passive: true });
  }
})();
